export interface ILookupItem {
    id: number;
    id2?: number;
    text: string;
    text2?: string;
    isSet?: boolean;
  }

    export class LookupItem {
    id: number = 0;
    id2?: number | null = null;
    text: string = "";
    text2?: string | null = null;
    isSet?: boolean = false;
    pointer: any;
  }
